import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PURCHASE_ORDER', [
    'FORM',
    'TABLE_REQUISITION',
    'MOUNT'
])
